import { StyleSheet } from 'react-native'
import { Theme, ThemedText, ThemedView } from '@app/theme'
import BajajLogo from "../../assets/Icons/BajajLogo";
import { ThemedTouchableOpacity } from '@app/theme/Components';
import { CaretRight } from '../sharedComponents/Icons/index';
import { useTheme } from '@shopify/restyle';
import { useAppSelector } from '@app/store/hooks';
import CopyIcon from "../../assets/Icons/CopyIcon";
import Clipboard from '@react-native-clipboard/clipboard';
import { trackEvent } from '@app/utils';

const BajajPausedCard = ({handleNavigate} : {handleNavigate : () => void}) => {

      const loanAccountID = useAppSelector((state) => state?.auth?.userDetails?.linkedCredits[0]?.lenderCreditId);
  
         const copyToClipboard = () => {
              trackEvent('BFL_NOTICE_COPY_LOAN_ACCOUNT_NUMBER_CLICKED')
              Clipboard.setString(loanAccountID ?? '');
          };

  const {colors} = useTheme<Theme>()
  return (
    <ThemedTouchableOpacity onPress={handleNavigate} borderWidth={1} borderColor='border-primary' mt='xl' bg='bg-fill-primary' marginHorizontal='lg' padding='lg' borderRadius='lg'>
      <ThemedText color='text-primary' mt='md' variant='h6b'>Important Update: Bajaj Finance Ltd. has discontinued its loan services & support via our platform.</ThemedText>
      <ThemedText variant='b4r' mt='sm' color='text-secondary'>Effective 1 Oct 2025, to manage your Bajaj LAS account please use Bajaj Finance channels directly</ThemedText>
      <ThemedView flexDirection='row' mt='md' alignItems='center'>
        <ThemedText variant='b4b' color='text-action-primary'>Know more</ThemedText>
        <CaretRight size={14} color={colors['text-action-primary']} />
      </ThemedView>

      <ThemedView mt='sm' height={1} bg='border-secondary' />
      <ThemedText mt='md' variant='b5r' textTransform='uppercase'>Your Loan A/C Number</ThemedText>
      <ThemedTouchableOpacity onPress={copyToClipboard} flexDirection='row' alignItems='center'>
      <ThemedText mr='sm' variant='b4b'>{loanAccountID}</ThemedText>
      <ThemedView flexDirection='row'>
      <CopyIcon size={20} color={colors['icon-action-primary']} />
      <ThemedText color='text-action-primary' ml='xs' variant='b5s'>Copy</ThemedText>
      </ThemedView>

      </ThemedTouchableOpacity>
    </ThemedTouchableOpacity>
  )
}

export default BajajPausedCard

const styles = StyleSheet.create({})